import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";

export function BorderExample() {
  return <Spinner animation="border" />;
}

const My404Route = (props) => {
  // useEffect(() => {
  //   window.location.reload();
  // }, []);

  return (
    <div className="p-3 text-center py-5">
      <BorderExample />
    </div>
  );
};

export default My404Route;
